
import Tooltip from '../common/toolTip';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MDBDataTable } from 'mdbreact';
import axios from 'axios';
import { ROUTE_BASE_URL, baseUrl } from '../../api/common';
import AddAdminUserComponent from './AddAdminUserComponent';
import DeleteAdminUserComponent from './DeleteAdminUserComponent';
import { useUser } from './UserContext';
const AdminUsers = () => {
    const { checkPermission } = useUser();
    const [addPopupStatus, setAddPopupStatus] = useState(false);

    const [updateData, setUpdateData] = useState({});

    const [eventType, setEventType] = useState('');

    const handleAddPopup = async(status, type, data) => {
        setUpdateData(data);
        setEventType(type);
        if(type==="Add"){
            const hasPermission = await checkPermission("Users", "create");
            if (!hasPermission) return;
          }else{
            const hasPermission = await checkPermission("Users", "update");
            if (!hasPermission) return;
        }
        setAddPopupStatus(status);
        setViewPopupStatus(false);
    };

    const [viewPopupStatus, setViewPopupStatus] = useState(false);

    const handleViewPopup = (type, data) => {
        setUpdateData(data);
        setEventType(type);
        setViewPopupStatus(true);
    };

    const handleViewPopupClose = () => {
        setEventType('');
        setUpdateData({});
        setViewPopupStatus(false);
    };

    const [deletePopupStatus, setDeletePopupStatus] = useState(false);
    const [deleteId, setDeleteId] = useState();
    const handleDelete = async (id) => {
        setDeleteId(id);      
        const hasPermission = await checkPermission("Users", "delete");
        if (!hasPermission) return;      
        setDeletePopupStatus(true);
    };

    const handleCloseDelete = () => {
        setDeletePopupStatus(false);
        setViewPopupStatus(false);
    };
    const [adminUsersData, setAdminUsersData] = useState([]);
    const fetchAdminUsersData = async () => {
        try {
            const response = await axios.get(
                `${baseUrl}/api/get_user`,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: localStorage.getItem('access_token'),
                    },
                }
            );
            if (response.data.status) {
                setAdminUsersData(response.data.data);
            } else {
                console.error('Error: Failed to fetch user data');
            }

        } catch (error) {
            console.error('Error fetching users data:', error);
        }
    };


    const body = {
        columns: [
            {
                label: 'S.No',
                field: 'sno',
                attributes: {
                    style: { width: '2%' },
                },
            },
            {
                label: 'Name',
                field: 'name',
                attributes: {
                    'aria-controls': 'DataTable',
                    'aria-label': 'Name',
                    style: { width: '15%' },
                },
            },
            {
                label: 'Email',
                field: 'email',
                sort: 'disabled',
                attributes: {
                    style: { width: '15%' },
                },
            },
            {
                label: 'Role',
                field: 'role',
                sort: 'disabled',
                attributes: {
                    style: { width: '15%' },
                },
            },
            {
                label: 'Action',
                field: 'action',
                attributes: {
                    style: { width: '6%' },

                },
            },
        ],
        rows: adminUsersData && adminUsersData.map((data, index) => ({
            sno: index + 1,
            name: data.full_name || "N/A",
            email: data.email || "N/A",
            role: data.role_name || "N/A",
            action: (
                <div>
                    <Tooltip text="Update" id="update" />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleAddPopup(true, "Update", data); }}
                        className="btn btn-sm btn-default edit_button_package"
                        title="Edit"
                        data-for="update"
                        data-tip
                    >
                        <i className="fa fa-edit"></i>
                    </button>
                    <Tooltip text="Delete" id="delete" />
                    <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleDelete(data.id); }}
                        className="btn btn-sm btn-default delete_button_package"
                        title="Delete"
                        data-for="delete"
                        data-tip
                    >
                        <i className="fa fa-trash"></i>
                    </button>
                </div>
            ),
            clickEvent: () => handleViewPopup("Update", data),
        })),
    }
      // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false); 
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Admin Users", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error fetching super specialty data:", error);
    }finally{
      setCheckUserLoading(false);
    }
  };
  useEffect(() => {
    fetchPermission();
  }, []);

    useEffect(() => {
        fetchAdminUsersData();
    }, []);
    return (
        <> {checkUserLoading? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
            ) : (
            <div className="container-fluid">
                <div className="block-header">
                    <div className="row clearfix">
                        <div className="col-md-6 col-sm-12">
                            <h1>Admin Users</h1>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                                    <li className="breadcrumb-item active" aria-current="page">Admin Users</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="col-md-6 col-sm-12 text-right hidden-xs">
                            <span onClick={() => handleAddPopup(true, "Add", {})} className="btn btn-outline-primary mr-1" title="">Add New</span>
                        </div>
                    </div>
                </div>
                <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="body">
                                <div className="table-responsive">
                                    <MDBDataTable
                                        noBottomColumns
                                        className="table table-hover js-basic-example dataTable table-custom spacing5"
                                        entriesOptions={[5, 10, 20, 25]}
                                        entries={10}
                                        paging
                                        pagesAmount={15}
                                        data={body}
                                        sortRows={['title']}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <AddAdminUserComponent fetchAdminUsersData={fetchAdminUsersData} eventType={eventType} updateData={updateData} addPopupStatus={addPopupStatus} handleAddPopup={handleAddPopup} />
                <DeleteAdminUserComponent fetchAdminUsersData={fetchAdminUsersData} deleteId={deleteId} deletePopupStatus={deletePopupStatus} handleCloseDelete={handleCloseDelete} />
                {/* <div className={`extraspace_search_div search_div${isSearchbar1 ? " open" : ""}`}>
                    <div className="card member_master_sidebar_scrool">
                        <div className="member_edit_pop_flex mb-3 text-end">
                            <h3>View User</h3>
                            <div className="input-group-append d-flex gap-10">
                                <div>
                                    <button class="saveand_proced_button btn btn btn-outline-danger btn-block" type="button"><i class="icon-trash"></i> Delete </button>
                                </div>
                                <div>
                                    <button onClick={handleButtonClick} class="saveand_proced_button btn btn-outline-info btn-block" type="button"><i class="fa fa-edit"></i> Edit </button>
                                </div>
                                <span onClick={() => toggleSearchBar1(false)} className="search_toggle btn btn-danger"><i className="fa fa-times"></i></span>
                            </div>
                        </div> 
                        <div className="table-responsive">
                            <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                        <div className="col-md-12">
                                            <div className="card">                                             
                                                <div className="body">
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Name:</b> </small>
                                                            <p>Bharathi</p>
                                                        </div>
                                                        <div className="col-6">
                                                            <small className="text-muted"><b>Email address: </b></small>
                                                            <p>Bharathi@example.com</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <small className="text-muted"><b>Role:</b> </small>
                                                            <p>Medical Administrative</p>
                                                        </div>
                                                        <div className="col-12">
                                                            <div className='pb-2'>
                                                                <small className="text-muted "><b >Permision:</b></small>
                                                            </div>
                                                            <div className='permision_grid_view'>
                                                                <p className='permision_div_span'>managing patient records</p>
                                                                <p className='permision_div_span'>accessing sensitive medical data</p>
                                                                <p className='permision_div_span'>healthcare providers</p>
                                                                <p className='permision_div_span'>Medical Administrative</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                </div> */}
            </div>)}
        </>
    );

}
export default AdminUsers
